import React from "react";
import { useTranslation } from "react-i18next";

import securityImg from '../../img/AboutUs/rec7.webp';
import Fade from 'react-reveal/Fade';

const mobileItems = [
  { titleKey: "about.security.1.title", textKey: "about.security.1.text" },
  { titleKey: "about.security.2.title", textKey: "about.security.2.text" },
  { titleKey: "about.security.3.title", textKey: "about.security.3.text" },
];

function Security() {
  const { t } = useTranslation();

  return (
    <section className="mt-[80px] xl:mt-[160px]">
      {/* ── Desktop: 3-col × 2-row grid ── */}
      <div className="hidden xl:block">
        <div className="relative mx-auto h-[386px] max-w-[1220px] overflow-hidden">

          {/* ── Column 1 top: title + line + text ── */}
          <Fade bottom>
          <div className="absolute left-0 top-0 w-[488px]">
            <h2 className="mt-[18px] font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
              {t("about.security.title")}
            </h2>
            <p className="mt-[10px] w-[427px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.4] text-[#05193a]">
              {t("about.security.text2")}
            </p>
          </div>

          </Fade>
          {/* ── Column 1 bottom: image ── */}
          <Fade bottom delay={100}>
          <div className="absolute left-0 top-[193px] h-[193px] w-[488px] overflow-hidden">
            <img src={securityImg} alt="" className="h-full w-full object-cover" />
          </div>

          </Fade>
          {/* ── Column 2 top: Item 1 ── */}
          <Fade bottom delay={150}>
          <div className="absolute left-[508px] top-[21px] w-[325px]">
            <p className="font-['Nunito_Sans'] text-[16px] font-black leading-[1.4] text-[#05193a]">
              {t("about.security.1.title")}
            </p>
            <p className="mt-[10px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.4] text-[#05193a]">
              {t("about.security.1.text")}
            </p>
          </div>

          </Fade>
          {/* ── Column 2 bottom: Item 2 ── */}
          <Fade bottom delay={200}>
          <div className="absolute left-[508px] top-[225px] w-[325px]">
            <p className="font-['Nunito_Sans'] text-[16px] font-black leading-[1.4] text-[#05193a]">
              {t("about.security.2.title")}
            </p>
            <p className="mt-[10px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.4] text-[#05193a]">
              {t("about.security.2.text")}
            </p>
          </div>

          </Fade>
          {/* ── Column 3 top: Item 3 ── */}
          <Fade bottom delay={250}>
          <div className="absolute left-[873px] top-[21px] w-[325px]">
            <p className="font-['Nunito_Sans'] text-[16px] font-black leading-[1.4] text-[#05193a]">
              {t("about.security.3.title")}
            </p>
            <p className="mt-[10px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.4] text-[#05193a]">
              {t("about.security.3.text")}
            </p>
          </div>

          </Fade>
          {/* ── Column 3 bottom: blue bg + text ── */}
          <Fade bottom delay={300}>
          <div className="absolute left-[853px] top-[193px] h-[193px] w-[367px] bg-[#daebfc]">
            <p className="absolute left-[20px] top-[32px] w-[291px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.4] text-[#05193a]">
              {t("about.security.text1")}
            </p>
          </div>

          </Fade>
          {/* ── Grid dividers (drawn last) ── */}
          <div className="absolute left-[488px] top-0 h-full w-px bg-[#d3d3d3]" />
          <div className="absolute left-[853px] top-0 h-full w-px bg-[#d3d3d3]" />
          <div className="absolute left-0 top-[193px] h-px w-full bg-[#d3d3d3]" />
        </div>
      </div>

      {/* ── Mobile ── */}
      <Fade bottom>
      <div className="xl:hidden mx-auto max-w-[1220px] px-[20px]">
        <h2 className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4]">
          {t("about.security.title")}
        </h2>
        <span className="mt-[10px] block h-[4px] w-[104px] bg-[#05193a]" />
        <p className="mt-[20px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
          {t("about.security.text2")}
        </p>
        <div className="mt-[30px] flex flex-col">
          {mobileItems.map((item, i) => (
            <div
              key={i}
              className="border border-[#bcbcbc] px-[18px] py-[24px] -mt-px"
            >
              <p className="font-['Nunito_Sans'] text-[16px] font-black leading-[1.4] text-[#05193a]">
                {t(item.titleKey)}
              </p>
              <p className="mt-[8px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.4] text-[#05193a]">
                {t(item.textKey)}
              </p>
            </div>
          ))}
        </div>
        <p className="mt-[20px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.4] text-[#05193a]">
          {t("about.security.text1")}
        </p>
      </div>
      </Fade>
    </section>
  );
}

export default Security;
